<template>
  <div>
    <b-row class="m-0 pt-3 justify-content-center">
      <div>
       <b-img-lazy :src="require(`@/assets/logos/eatDoradoLogo.png`)" class="" style=" max-width: 90%; width: 300px; height: 200px" fluid alt="eatDorado Logo"></b-img-lazy>  
      </div>
    </b-row>
    <b-row class="m-0 mt-5 justify-content-center">
      <h1>Konto erstellen</h1>
    </b-row>
    <b-row class="m-0 mt-4 justify-content-center">
      
      <div style="width: 600px; max-width: 100%" class="mx-3">
        <h4 class="text-center">Jetzt registrieren und schneller bestellen!</h4>

        <div v-if="!accountCreated">
          <b-form class="mt-5" @submit.prevent="submitForm()">

            <b-form-group
            label="Deine E-Mail-Adresse:"
            >
              <b-form-input
                :state="registerStateEmail && !authError ? true : false"
                v-model="form.email"
                id="email"
                type="email"
                required
              ></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback">
                <span v-if="!registerStateEmail && !authMessage">Bitte eine gültige E-Mail-Adresse eingeben</span>
                <span v-if="authMessage">{{authMessage}}</span>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group >
              <b-form-checkbox-group
                :state="!form.checked.length > 0 ? false : true"
                v-model="form.checked"
                id="dsgvo-accepted"
                required
              >
              <b-form-checkbox value="me">Die Informationen zum <a href="/datenschutz" target="_blank">Datenschutz</a> habe ich gelesen und stimme zu.</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>

            <b-button type="submit" style="width: 100%" size="md" variant="dark">Konto erstellen</b-button>
            <p class="text-center m-0 mb-3 mt-5">Du hast schon ein Konto?</p>
            <b-button style="width: 100%" size="md" variant="dark" @click="$router.push('/login').catch(err => {})">Zur Anmeldung</b-button>
          </b-form>
        </div>
        <div v-else class="my-5">
          <h3 class="text-center text-success">Wir haben Dir eine Bestätigungs-E-Mail zugesendet!</h3>
          <p class="my-4 text-center">Bitte überprüfe auch Deinen Spamordner.</p>
          <b-button style="width: 100%" size="md" variant="dark" @click="$router.push('/login').catch(err => {})">Zur Anmeldung</b-button>
        </div>
      </div>
    </b-row>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/Footer'
import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'Register',
  mixins: [coreData],
  data: () => {
    return {
      form: {
        email: '',
        checked: [],
        
      },
      regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  components: {
    Footer
  },
  computed: {
    accountCreated(){
      return this.$store.getters.accountCreated
    },
    darkMode(){
      return this.$store.getters.darkMode
    },
    contactFormSent(){
      return this.$store.getters.contactFormSent
    },
    registerStateEmail() {
      return this.regex.test(this.form.email)? true : false
    },
  },
  watch:{
    contactFormSent(){
      if(this.contactFormSent){
        this.form = {}
      }
    },
    form: {
      handler: function () {
        this.$store.commit('authError', null)
        this.$store.commit('authMessage', null)
      },
      deep: true
    },
  },
  mounted() {
  },
  methods: {
    submitForm(){
      if(this.form.checked.length == 0) return
      this.$store.dispatch('signup', this.form)
    } 
  }
}
</script>